/* Petifo · sticky Add-to-cart + Shopify chat, side by side.

   WHY THIS FILE EXISTS: the theme kills the sticky bar as soon as a chat
   component exists. From assets/sticky-add-to-cart.js (Petifo's theme version,
   14 KB — Djurslottet runs an older 6.5 KB build with none of this, which is why
   both work over there):

     #isChatActive(){ return customElements.get("shopify-chat")
                        ? !!document.querySelector("shopify-chat") : false }
     hideStickyBar(){ this.#isStuck = false; stickyBar.dataset.stuck = "false" }

   Shopify Inbox used to render <inbox-online-store-chat>, so the branch never
   ran. Shopify migrated to the native <shopify-chat> and the bar disappeared.

   RULES OF THE ROAD
   1. Never fight over data-stuck — the theme rewrites it instantly and it
      ping-pongs. The theme keeps owning that attribute.
   2. Reveal the bar with INLINE styles at priority 'important'. A stylesheet
      rule loses: the theme hides it from a cross-origin sheet whose specificity
      beat element + 2 classes + attribute + !important.
   3. CENTERING — ASK THE THEME, EVERY TICK. The theme packs centering AND
      hiding into ONE transform, `translate(-50%) translateY(calc(100% + 80px))`.
      Overwriting it to un-hide the bar therefore throws the centering away too,
      so the reveal has to put the X back — and the right X is DIFFERENT per
      breakpoint:
        desktop — theme centres with `left:50%` + `width:600px`     -> -50%
        phones  — pf-sticky-price.liquid pins `left:0; right:0`      -> none

      baseX() gets it from the only authority that is always right: it removes
      our own inline transform, reads the computed transform the CSS produces
      for the CURRENT breakpoint, and keeps its m41. Desktop yields -300 (-50%
      of the 600px bar); the phone rule carries no X at all, so it yields 0.

      FOUR EARLIER ATTEMPTS EACH FIXED ONE SIDE AND BROKE THE OTHER — do not
      reintroduce any of them:
        a) the same reading, but CACHED after the first tick. Two failure modes,
           both landing the bar RIGHT on desktop: if that tick beat the theme's
           CSS the captured value was 0, and a frozen pixel value never follows
           a resize while the theme's own -50% does.
        b) -50% inferred from whether the CSS `left` equalled half the viewport.
        c) a matchMedia('(max-width:749px)') guess.
        d) measure-and-correct from getBoundingClientRect().
      (b), (c) and (d) all re-implement a breakpoint decision that the CSS has
      already made correctly. Reading it back is shorter and cannot disagree.

      NOTE FOR WHOEVER VERIFIES THIS: you cannot check it in the browser
      automation. Inline styles on this element have no effect there — measured
      directly, `transform: translateX(400px) !important` left the computed
      transform at `matrix(1,0,0,1,-300,114.391)` and the bar at x=456,
      unchanged. Anything you "confirm" there is the theme's untouched resting
      state. Verify on a real device, or from a full-width screenshot (Peji's
      are dpr 2 — halve the pixel dimensions first, or a correct 600px bar looks
      like a broken 1200px one).
   4. The chat launcher is `button.activator` inside <shopify-chat>'s SHADOW
      ROOT — outside CSS cannot reach it. Inject a stylesheet into that shadow
      root and toggle it with a host attribute.
   5. The bar hides again at the footer, and while the chat PANEL is open (the
      bar otherwise covers the chat's own controls). */
(function () {
  'use strict';

  var PROPS = ['opacity', 'transform', 'visibility', 'pointer-events'];
  var lastShown = null;

  function barEl() {
    var s = document.querySelector('sticky-add-to-cart');
    if (!s) return null;
    return s.querySelector('.sticky-add-to-cart__bar');
  }

  function anchorEl() {
    var a = document.querySelector('add-to-cart-component');
    if (a) return a;
    return document.querySelector('button[name="add"]');
  }

  function footerEl() { return document.querySelector('footer'); }
  function chatEl() { return document.querySelector('shopify-chat'); }

  /* The chat panel is open -> stay out of its way completely */
  function chatOpen() {
    var c = chatEl();
    if (c && c.hasAttribute('open')) return true;
    if (document.querySelector('#chat-drawer[open]')) return true;
    if (document.querySelector('.chat-drawer[open]')) return true;
    return false;
  }

  /* See rule 3 — the CSS already knows; read it back, never cache it. */
  function baseX(b) {
    b.style.removeProperty('transform');
    var t = getComputedStyle(b).transform;
    if (!t || t === 'none') return 0;
    try {
      return new DOMMatrixReadOnly(t).m41 || 0;
    } catch (e) {
      return 0;
    }
  }

  function ensureChatStyle() {
    var c = chatEl();
    if (!c || !c.shadowRoot) return null;
    if (c.shadowRoot.querySelector('#pf-chat-lift')) return c;
    var st = document.createElement('style');
    st.id = 'pf-chat-lift';
    st.textContent = '.activator{transition:transform .25s ease}:host([data-pf-lift="1"]) .activator{transform:translateY(-86px)}';
    c.shadowRoot.appendChild(st);
    return c;
  }

  function liftChat(on) {
    var c = ensureChatStyle();
    if (!c) return;
    if (on) {
      if (c.getAttribute('data-pf-lift') !== '1') c.setAttribute('data-pf-lift', '1');
    } else if (c.hasAttribute('data-pf-lift')) {
      c.removeAttribute('data-pf-lift');
    }
  }

  function show(b) {
    b.classList.add('pf-force-stick');
    b.style.setProperty('opacity', '1', 'important');
    b.style.setProperty('visibility', 'visible', 'important');
    b.style.setProperty('pointer-events', 'auto', 'important');
    b.style.setProperty('transform', 'translateX(' + baseX(b) + 'px)', 'important');
  }

  function hide(b) {
    b.classList.remove('pf-force-stick');
    PROPS.forEach(function (p) { b.style.removeProperty(p); });
  }

  function recompute() {
    var b = barEl();
    var a = anchorEl();
    if (!b || !a) return;

    var scrolledPast = a.getBoundingClientRect().bottom < 0;

    var atFooter = false;
    var f = footerEl();
    if (f) atFooter = f.getBoundingClientRect().top < window.innerHeight;

    var open = chatOpen();
    var want = scrolledPast && !atFooter && !open;

    if (want) {
      show(b);
      if (lastShown !== true) { lastShown = true; liftChat(true); }
    } else if (lastShown !== false) {
      hide(b);
      lastShown = false;
      liftChat(false);
    } else if (open) {
      /* keep it down while the chat is open, even on repeat ticks */
      hide(b);
      liftChat(false);
    }
  }

  var bound = false;

  function bind() {
    if (bound) return;
    bound = true;

    var raf = false;
    var onScroll = function () {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () { raf = false; recompute(); });
    };
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', recompute, { passive: true });
    window.addEventListener('orientationchange', recompute, { passive: true });

    /* react to the chat opening/closing immediately, not on the next poll */
    var c = chatEl();
    if (c) {
      try {
        new MutationObserver(recompute).observe(c, { attributes: true, attributeFilter: ['open', 'mode'] });
      } catch (e) {}
    }
    document.addEventListener('shopify-chat:enter-managed', recompute);
    document.addEventListener('shopify-chat:enter-standalone', recompute);
    document.addEventListener('shopify-chat:close', recompute);
  }

  bind();
  setInterval(function () {
    if (!bound) bind();
    recompute();
  }, 300);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recompute);
  } else {
    recompute();
  }
})();